export default __webpack_public_path__ + "static/media/042-apple.211d891c.svg";